import { render, staticRenderFns } from "./ProductCategoryIcon.vue?vue&type=template&id=239dd212&scoped=true"
import script from "./ProductCategoryIcon.vue?vue&type=script&lang=js"
export * from "./ProductCategoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239dd212",
  null
  
)

export default component.exports